
import { defineComponent, PropType, watch, ref, computed, onMounted } from 'vue'
import { store } from '@/store'
import AppDropdown from '@/components/atoms/AppDropdown.vue'

import { getPlaceSymbol } from '@/api/tripply'
import { Route, Place, RouteLiveState } from '@/api/tripply/models'

export default defineComponent({
  name: 'RoutePlace',
  components: { AppDropdown },
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    },
    place: {
      type: Object as PropType<Place>,
      required: true
    },
    placeIndex: {
      type: Number,
      required: true
    },
    liveState: {
      type: [Object, Boolean] as PropType<RouteLiveState>,
      required: true
    },
    isDragging: Boolean,
    hideData: Boolean,
    canEdit: Boolean
  },
  setup(props) {
    const placeRef = ref<HTMLElement | null>(null)
    const isOwner = computed(() => store.user.isOwner(props.route.id))
    const isExpanded = ref(false)

    function edit() {
      props.canEdit && store.modal.showModal('PlaceSettings', {routeId: props.route.id, placeIndex: props.placeIndex, place: props.place})
    }
    function setFirst() {
      store.route.setPlaceFirst(props.route.id, props.placeIndex)
    }
    function setLast() {
      store.route.setPlaceLast(props.route.id, props.placeIndex)
    }
    function remove() {
      store.route.deletePlace(props.route.id, props.placeIndex)
    }
    function onClick() {
      isExpanded.value = !isExpanded.value
    }
    function focus() {
      store.map.focus(props.place)
    }

    function scrollIntoView() {
      if (props.place.live?.latest) {
        placeRef.value && placeRef.value.scrollIntoView()
      }
    }
    
    watch(() => props.liveState, () => {
      scrollIntoView()
    })

    onMounted(() => {
      setTimeout(() => {
        scrollIntoView()
      }, 2000)
    })

    return { isOwner, onClick, focus, remove, edit, setFirst, setLast, isExpanded, getPlaceSymbol, placeRef }
  }
})
